import React from 'react';
import './AccountHero.css';

const AccountHero = () => {
    return (
        <section className="account-hero">
            <div className="account-hero-container">
                <div className="account-hero-content">
                    <h1 className="account-hero-title">
                        <span className="account-hero-title-line">
                            Expert <span className="account-hero-title-highlight">Accounting & Tax Services</span>
                        </span>{' '}
                        <span className="account-hero-title-line account-hero-title-tagline">Built Around You</span>
                    </h1>
                    <p className="account-hero-description">
                        Whether you're an individual, a small business, or a sole trader, we provide smart,
                        tailored financial solutions — from tax returns to bookkeeping, advisory, and
                        superannuation support.
                    </p>
                    <div className="account-hero-buttons">
                        <a className="account-hero-btn account-hero-btn-primary" href='/contact'>
                            Request a Quote
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AccountHero;
